<template>
  <app-view title="購買流程" :backable="true">
    <div class="p-5">
      <img :src="imgs.procedure" alt="" />
    </div>
  </app-view>
</template>

<script>
import {mapGetters} from "vuex";
export default {
  auth: false,
  head() {
    return {
      title: `${process.env.APP_NAME}-購買流程`,
      meta: [
        {
          hid: "keywords",
          name: "keywords",
          content: `${process.env.APP_NAME},${process.env.APP_NAME}-購買流程`,
        },
        {
          hid: "description",
          name: "description",
          content: `${process.env.APP_NAME}購買流程幫助您在本平台進行愉快的購物。`,
        },
        {
          hid: "og:title",
          name: "og:title",
          property: "og:title",
          content: `${process.env.APP_NAME}-購買流程`,
        },
        {
          hid: "og:site_name",
          name: "og:site_name",
          property: "og:site_name",
          content: `${process.env.APP_NAME}`,
        },
        {
          hid: "og:url",
          name: "og:url",
          property: "og:url",
          content: `${process.env.APP_URL}/procedure`,
        },
        {
          hid: "og:description",
          name: "og:description",
          property: "og:description",
          content: `${process.env.APP_NAME}購買流程幫助您在本平台進行愉快的購物。`,
        },
        {
          hid: "og:image",
          name: "og:image",
          property: "og:image",
          content: `${process.env.APP_URL}/static/icon.png`,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      imgs: "app/imgs",
    }),
  },
};
</script>

<style lang="scss" scoped></style>
